import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import CaptionFont from '../../Theme/Fonts/Caption'
import { BasicCardHeadlineProps, CardHeadlineWithRightItemProps } from '..'
import { WebHeadlineType } from '../../Theme/Fonts/BasicText'
import BasicCardHeadline from '../HelperClass/BasicCardHeadline'
import InfoLabel from '../../BaseComponents/InfoLabel'

export type CardHeadlineWithTextProps = CardHeadlineWithRightItemProps &
    WebHeadlineType & {
        type: 'SELECTABLE_TEXT'
        /** small text on the right */
        selectableText: string
        /** icon on the right */
        icon?: never
        /**decide between PlayerImage circled and default image with square shape */
        imageType?: 'DEFAULT' | 'PLAYER'
        /**to display an image on the left from the headline */
        imageUrl?: string
    } & BasicCardHeadlineProps

const CardHeadlineWithTextComponent: FunctionComponent<CardHeadlineWithTextProps> = ({
    text,
    selectableText,
    webHeadlineType,
    onRightItemPress,
    textColor,
    backgroundColor = 'pearl',
    infoLabel,
    testID,
    imageUrl,
    imageType = 'DEFAULT',
}): ReactElement => {
    return (
        <Grid testID={testID} noExpand horizontal centerVertical backgroundColor={backgroundColor}>
            <BasicCardHeadline
                webHeadlineType={webHeadlineType}
                imageUrl={imageUrl}
                imageType={imageType}
                text={text}
                textColor={textColor}
            />
            <Grid horizontal noExpand centerVertical alignRight marginLeft={4}>
                {infoLabel ? <InfoLabel infoLabel={infoLabel} marginRight={3} /> : null}
                <Touchable onPress={onRightItemPress}>
                    <CaptionFont numberOfLines={1} color="keshi-3">
                        {selectableText}
                    </CaptionFont>
                </Touchable>
            </Grid>
        </Grid>
    )
}

export default memo(CardHeadlineWithTextComponent)
